import angular from 'angular';
import * as Configuration from 'src/ajs-app/app.constants.js';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';
import { isActive } from './navigationUtils.js';

NavigationPublishController.$inject = ['$scope', 'loggedUser', 'sites', 'SiteFilterHelperFactory', 'StrategiesFactory', '$stateParams', '$state', 'publishCounts', 'TopToolbarFactory'];
export function NavigationPublishController($scope, loggedUser, sites, SiteFilterHelperFactory, StrategiesFactory, $stateParams, $state, publishCounts, TopToolbarFactory) {

  init();
  $scope.setSelectedMenu = setSelectedMenu;


  function setSelectedMenu(mySelectedKey) {
    angular.forEach($scope.navigation.publish, function (navObj, key) {
      $scope.navigation.publish[key].isSelected = `${mySelectedKey}` === `${key}`;
    });
  }

  function switchSite() {
    if ($scope.filteredSiteId !== $stateParams.siteId) {
      $state.go('.', {
        companyId: $stateParams.companyId,
        siteId: $scope.filteredSiteId
      });
    }
  }


  function init() {
    TopToolbarFactory.setSubNavBurger($scope);
    const localStorageKey = `publish-nav-filtered-site-id-for-company-${$stateParams.companyId}`;
    const higherPriorityinitialValue = $stateParams.siteId;
    const hasAllSitesItem = false;
    const filteredSites = SiteFilterHelperFactory
      .filterSitesThatHaveCapability(sites, loggedUser, CapabilityIdEnum.Publish)
      .filter(site => StrategiesFactory.getStrategyFromType(site.type).handlesPublish());
    SiteFilterHelperFactory.initScope($scope, filteredSites, localStorageKey, higherPriorityinitialValue, hasAllSitesItem);
    $scope.$watch('filteredSiteId', switchSite);

    let v3BaseUrl = Configuration.constants.frontendBaseUrl + '#/';
    /* Variables definition */
    $scope.navigation = {
      'publish': {
        'drafts': {
          'isSelected': isActive($state, 'publish.drafts'),
          'count': publishCounts.drafts,
          'class': 'bullet-orange',
          'url': v3BaseUrl + $stateParams.companyId + '/publish/' + $stateParams.siteId + '/drafts'
        },
        'scheduled': {
          'isSelected': isActive($state, 'publish.scheduled'),
          'count': publishCounts.scheduled,
          'class': 'bullet-green',
          'url': v3BaseUrl + $stateParams.companyId + '/publish/' + $stateParams.siteId + '/scheduled'
        },
        'sent': {
          'isSelected': isActive($state, 'publish.sent'),
          'count': publishCounts.sent,
          'class': 'bullet-blue',
          'url': v3BaseUrl + $stateParams.companyId + '/publish/' + $stateParams.siteId + '/sent'
        },
        'archived': {
          'isSelected': isActive($state, 'publish.archived'),
          'count': publishCounts.archived,
          'class': 'bullet-turquoise',
          'url': v3BaseUrl + $stateParams.companyId + '/publish/' + $stateParams.siteId + '/archived'
        }
      }
    };


    $scope.$on('incDraftsCounter', function (evt, value) {
      $scope.navigation.publish.drafts.count = $scope.navigation.publish.drafts.count + parseInt(value);
    });
    $scope.$on('decDraftsCounter', function (evt, value) {
      $scope.navigation.publish.drafts.count = $scope.navigation.publish.drafts.count - parseInt(value);
    });


    $scope.$on('incScheduledCounter', function (evt, value) {
      $scope.navigation.publish.scheduled.count = $scope.navigation.publish.scheduled.count + parseInt(value);
    });

    $scope.$on('decScheduledCounter', function (evt, value) {
      $scope.navigation.publish.scheduled.count = $scope.navigation.publish.scheduled.count - parseInt(value);
    });

    $scope.$on('incArchiveCounter', function (evt, value) {
      $scope.navigation.publish.archived.count = $scope.navigation.publish.archived.count + parseInt(value);
    });
  }

}
